import React from 'react';
import { useNavigate } from 'react-router-dom';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const FeaturedTrailers = () => {
  const navigate = useNavigate();

  const featuredTrailers = [];


  const handleViewDetails = (trailerId) => {
    navigate('/trailer-detail', { state: { trailerId } });
  };

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-foreground mb-3 md:mb-4">
            Featured Trailers
          </h2>
          <p className="font-body text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
            Discover top-rated trailers available for rent in your area
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 lg:gap-8">
          {featuredTrailers?.map((trailer) =>
          <div
            key={trailer?.id}
            className="bg-card rounded-lg shadow-elevation-2 overflow-hidden transition-smooth hover:shadow-elevation-4 cursor-pointer"
            onClick={() => handleViewDetails(trailer?.id)}>
            
              <div className="relative h-48 md:h-56 lg:h-64 overflow-hidden">
                <Image
                src={trailer?.image}
                alt={trailer?.imageAlt}
                className="w-full h-full object-cover transition-smooth hover:scale-105" />
              
                <div className="absolute top-3 right-3 bg-primary text-primary-foreground px-3 py-1 rounded-md font-body font-medium text-sm">
                  ${trailer?.price}/day
                </div>
                <div className="absolute top-3 left-3 bg-secondary/90 text-secondary-foreground px-3 py-1 rounded-md font-caption text-xs">
                  {trailer?.type}
                </div>
              </div>

              <div className="p-4 md:p-5 lg:p-6">
                <h3 className="font-heading font-semibold text-lg md:text-xl text-foreground mb-2 line-clamp-2">
                  {trailer?.name}
                </h3>

                <div className="flex items-center space-x-2 mb-3">
                  <div className="flex items-center space-x-1">
                    <Icon name="Star" size={16} color="var(--color-accent)" strokeWidth={2} fill="var(--color-accent)" />
                    <span className="font-body font-medium text-sm text-foreground">{trailer?.rating}</span>
                  </div>
                  <span className="font-caption text-xs text-muted-foreground">
                    ({trailer?.reviews} reviews)
                  </span>
                </div>

                <div className="flex items-center space-x-2 mb-4">
                  <Icon name="MapPin" size={16} color="var(--color-muted-foreground)" strokeWidth={2} />
                  <span className="font-body text-sm text-muted-foreground">{trailer?.location}</span>
                </div>

                <div className="grid grid-cols-2 gap-3 mb-4 pb-4 border-b border-border">
                  <div>
                    <p className="font-caption text-xs text-muted-foreground mb-1">Capacity</p>
                    <p className="font-body font-medium text-sm text-foreground whitespace-nowrap">{trailer?.capacity}</p>
                  </div>
                  <div>
                    <p className="font-caption text-xs text-muted-foreground mb-1">Size</p>
                    <p className="font-body font-medium text-sm text-foreground whitespace-nowrap">{trailer?.size}</p>
                  </div>
                </div>

                <div className="space-y-2">
                  {trailer?.features?.slice(0, 2)?.map((feature, index) =>
                <div key={index} className="flex items-center space-x-2">
                      <Icon name="Check" size={14} color="var(--color-success)" strokeWidth={2.5} />
                      <span className="font-caption text-xs text-muted-foreground">{feature}</span>
                    </div>
                )}
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="text-center mt-8 md:mt-12">
          <button
            onClick={() => navigate('/search-results')}
            className="px-6 py-3 md:px-8 md:py-4 bg-secondary text-secondary-foreground font-body font-medium text-base md:text-lg rounded-md transition-smooth hover:opacity-90 shadow-elevation-2">
            
            View All Trailers
          </button>
        </div>
      </div>
    </section>
  );

};

export default FeaturedTrailers;